<div>
  <h1>Healthcare provider types</h1>
  <h2>
    <span>Affiliated Providers</span>
    <span class="ic-status-affiliated" title="Affiliated Provider"></span>
  </h2>
  <p>
    An Affiliated Provider is a doctor, specialist or medical facility contracted to provide Southern Cross members with
    certain healthcare services at agreed prices.
  </p>
  <p>
    Some healthcare services are
    <a
      target="_blank"
      href="https://www.southerncross.co.nz/society/for-members/Making-a-claim/Affiliated-Provider/Affiliated-Provider-only-healthcare-services"
      >'Affiliated Provider-only'</a
    >, which means they’re only covered by your policy if they're performed by an Affiliated Provider.
  </p>
  <p>
    Using an Affiliated Provider is also easier – no forms and no fuss as prior approval and claiming are sorted for you
    directly with them.
  </p>
  <p>
    <span class="is-consultant who-can-i-find-here"></span>
    <span>
      If you see this while you’re searching – this means an Affiliated Provider who performs specialist consultations.
      Please check their profile to ensure they offer the specific healthcare service or consultation you need.</span
    >
  </p>
  <p>
    <span class="is-telehealth who-can-i-find-here"></span>
    <span>
      This icon represents Affiliated Providers who perform specialist initial and follow-up consultations via
      telehealth. A telehealth consultation is the use of video or phone to deliver healthcare consultations when
      Southern Cross patients and Affiliated Providers are in different physical locations and when no physical
      examination is required.</span
    >
  </p>
  <p>
    If you're unable to find an Affiliated Provider near you that offers the healthcare service you need, please
    <a target="_blank" href="https://www.southerncross.co.nz/society/contact-us">contact us</a>. This is important for
    <a
      target="_blank"
      href="https://www.southerncross.co.nz/society/for-members/Making-a-claim/Affiliated-Provider/Affiliated-Provider-only-healthcare-services"
      >Affiliated Provider-only healthcare services</a
    >.
  </p>
  <h2>
    <span>Easy-Claim partners</span>
    <span class="ic-status-easy-claim" title="Easy-Claim"></span>
  </h2>
  <p>
    Easy-Claim partners provide a convenient way for Southern Cross members to claim for eligible day-to-day healthcare
    services at the time of purchase. Easy-Claim is available at participating General Practices, Optometrists,
    Dentists, Physiotherapists, Audiologists, Chiropractors, Podiatrists, Osteopaths, Remedial Massage Therapists, and
    Pharmacies.
  </p>
  <p>
    Just show your Member card (it’s on the app) or mention your member number and they’ll do the rest. If your plan
    covers the product or service, we'll reimburse the provider directly and you'll only pay any remaining contribution
    you're responsible for.
  </p>
  <p>
    <a target="_blank" href="https://www.southerncross.co.nz/society/for-members">Log in</a>
    to My Southern Cross to see your benefit balances and plan documents, or download the
    <a target="_blank" href="https://www.southerncross.co.nz/society/for-members/my-southern-cross/download-the-app"
      >My Southern Cross app</a
    >.
  </p>
</div>
